"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoSpeed = void 0;
const react_1 = __importStar(require("react"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const Tooltip_1 = __importDefault(require("@material-ui/core/Tooltip"));
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
const useStyles = (0, makeStyles_1.default)({
    speedBtn: {
        minWidth: 'auto !important',
        padding: '0 2px !important',
        fontSize: '10px !important',
        borderRadius: '2px !important',
        backgroundColor: 'white !important'
    }
});
exports.VideoSpeed = (0, react_1.memo)(({ videoElement }) => {
    const classes = useStyles();
    const [videoSpeed, setVideoSpeed] = (0, react_1.useState)(1);
    const increaseVideoSpeed = (0, react_1.useCallback)(() => {
        // React doesn't support playbackRate video attr, so we set it via ref
        if (videoElement) {
            setVideoSpeed(prevSpeed => {
                const newSpeed = prevSpeed === 2 ? 1 : prevSpeed + 0.25;
                videoElement.playbackRate = newSpeed;
                return newSpeed;
            });
        }
    }, [videoElement]);
    return (react_1.default.createElement(Tooltip_1.default, { title: "Change video speed" },
        react_1.default.createElement(Button_1.default, { color: "default", onClick: increaseVideoSpeed, size: "small", className: classes.speedBtn },
            react_1.default.createElement("b", null, `x${(Math.round(videoSpeed * 100) / 100).toFixed(videoSpeed === 1 || videoSpeed === 2 ? 1 : 2)}`))));
});
//# sourceMappingURL=video-speed.js.map